import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { userAtom } from "stores";
import { useSetRecoilState } from "recoil";

import { onUserRes } from "./helper";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const user = async () => axios.get(Routes.USER);

export const useUser = () => {
  const setUser = useSetRecoilState(userAtom);
  return useQuery({
    queryKey: [Keys.USER_QRY],
    queryFn: user,
    onSuccess: (res) => onUserRes({ user: res.data, setUser }),
    enabled: false,
    retry: false,
  });
};
